// extracted by mini-css-extract-plugin
export default {"wrapper":"WelcomeView_wrapper__2Iru-","buttonWrapper":"WelcomeView_buttonWrapper__4dUfu","likeAnimation":"WelcomeView_likeAnimation__peuwX"};